import { initContract } from "@ts-rest/core";
import { PlaidConnectionDto } from "@common/dto/plaidConnection/plaid-connection.dto";
import { CreatePlaidConnectionResponseDto } from "@common/dto/plaid/create-plaid-connection-response.dto";
import { AddNewPlaidAccountsResponseDto } from "@common/dto/plaid/add-new-plaid-accounts-response.dto";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    getLinkTokenForNewConnectionQuerySchema,
    getLinkTokenForExistingConnectionPathParamsSchema,
    getLinkTokenForExistingConnectionQuerySchema,
    addConnectionBodySchema,
    getConnectionsQuerySchema,
    connectionIdPathParamsSchema,
    getLinkTokenResponseSchema,
    relinkSuccessBodySchema,
    relinkSuccessResponseSchema,
} from "@common/schemas/plaid-connection.schema";

const c = initContract();

export const plaidConnectionContract = c.router(
    {
        getLinkTokenForNewConnection: {
            method: "GET",
            path: "/link-token",
            query: getLinkTokenForNewConnectionQuerySchema,
            responses: {
                200: getLinkTokenResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        getLinkTokenForExistingConnection: {
            method: "GET",
            path: "/link-token/:connectionId",
            pathParams: getLinkTokenForExistingConnectionPathParamsSchema,
            query: getLinkTokenForExistingConnectionQuerySchema,
            responses: {
                200: getLinkTokenResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        addConnection: {
            method: "POST",
            path: "/",
            body: addConnectionBodySchema,
            responses: {
                201: c.type<CreatePlaidConnectionResponseDto>(),
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        getConnections: {
            method: "GET",
            path: "/",
            query: getConnectionsQuerySchema,
            responses: {
                200: c.type<PlaidConnectionDto[]>(),
            },
        },
        addNewAccounts: {
            method: "POST",
            path: "/:connectionId/new-accounts",
            pathParams: connectionIdPathParamsSchema,
            body: c.noBody(),
            responses: {
                201: c.type<AddNewPlaidAccountsResponseDto>(),
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        deleteConnection: {
            method: "DELETE",
            path: "/:connectionId",
            pathParams: connectionIdPathParamsSchema,
            body: c.noBody(),
            responses: {
                200: c.noBody(),
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
                409: ErrorMessageSchema,
            },
        },
        onRelinkSuccess: {
            method: "POST",
            path: "/:connectionId/on-relink-success",
            pathParams: connectionIdPathParamsSchema,
            body: relinkSuccessBodySchema,
            responses: {
                201: relinkSuccessResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/plaid-connection",
    },
);
